import type { KidForm } from '../model/interfaces'

import { runApiWrite } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

import { useKidStore } from '../model/store'

interface KidUpdateApiOptions {
  kidId: number
  payload: KidForm
}

/** `PATCH /admin-api/kids/{kid}` — name, grade, VoIP and notes. */
export const useKidUpdateApi = async (options: KidUpdateApiOptions): Promise<boolean> => {
  const kidStore = useKidStore()

  return runApiWrite(useAdminRoutes('admin.kid.update', { kid_id: options.kidId }), {
    method: 'patch',
    payload: { ...options.payload },
    setLoading: kidStore.trackProcessing,
  })
}
